import { z } from 'zod'
import {
  workspaceMemberSchema,
  workspaceSchema,
  workspaceUserSchema
} from '../schemas/workspaces.schemas'

export type Workspace = z.infer<typeof workspaceSchema>

export enum WorkspaceStatus {
  ACTIVE = 'active',
  FINISHED = 'finished',
  CANCELED = 'canceled',
  PAUSED = 'paused'
}

export enum VisualizationType {
  REDIRECT = 'redirect',
  IFRAME = 'iframe'
}

export type WorkspaceUser = z.infer<typeof workspaceUserSchema>

export type WorkspaceMember = z.infer<typeof workspaceMemberSchema>
